<script setup lang="ts">
const { vacancy } = defineProps<{
  vacancy: Partial<Vacancy>
}>()

const { t } = useI18n({
  useScope: 'local',
})

// TODO: fixme
// Create a reactive reference to the vacancy prop
const vacancyRef = ref(vacancy)
// Watch for changes to the vacancy prop
watch(() => vacancy, (newVal) => {
  vacancyRef.value = newVal
}, { deep: true, immediate: true })

const {
  formattedTags,
  formattedDates,
  remainingDatesLabel,
  imageUrl,
  showOrganizationName,
} = useVacancySearchCard(vacancyRef)

const vacancyDetailRoute = useVacancyDetailRoute(vacancy)
</script>

<template>
  <SearchCard
    :to="vacancyDetailRoute"
    :title="vacancy.title"
    :description="vacancy.shortDescription || vacancy.fullDescription || t('noDescription')"
    :image-url="imageUrl"
    :organization-name="showOrganizationName ? vacancy.organizationName : undefined"
    :header-tags="formattedTags"
    :dates="formattedDates"
    :remaining-dates-label="remainingDatesLabel"
    header-class="h-40"
  />
</template>

<i18n lang="json">
{
  "en": {
    "tag.once": "Once",
    "tag.multipleDates": "On multiple dates",
    "tag.flexible": "Flexible",
    "tag.regularly": "Regularly",
    "tag.sjors_sportief": "Sjors Sportief & Creatief",
    "tag.max_vitaal": "Max Vitaal",
    "tag.free": "Free",
    "moreDates": "+ {count} other dates",
    "noDescription": "No description"
  },
  "nl": {
    "tag.once": "Eenmalig",
    "tag.multipleDates": "Op meerdere dagen",
    "tag.flexible": "Flexibel",
    "tag.regularly": "Regelmatig",
    "tag.sjors_sportief": "Sjors Sportief & Creatief",
    "tag.max_vitaal": "Max Vitaal",
    "tag.free": "Gratis",
    "moreDates": "+ {count} andere data",
    "noDescription": "Geen beschrijving"
  }
}
</i18n>
